exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-page-component .title{padding-top:10px}.header-page-component .title .title-page{margin-bottom:24px}.header-page-component .col-action-buttons{position:relative}.header-page-component .col-action-buttons .btn-new-person{background:#36f;border:1px solid #36f;border-radius:30px;width:163px;height:35px;padding:0;position:absolute;right:16px;top:-75px;cursor:pointer;z-index:999}", ""]);

// exports
